import { ROUTES } from 'gcs-common/constants/routes';
import { getHasPermission } from 'gcs-common/slices/currentUser/currentUserSelectors';
import { type PropsWithChildren, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

/**
 * Only renders children when the user has the appropriate permissions,
 * otherwise redirect the user to ROUTES.ROOT.
 */
const AdministrationProtectedRoute = ({ children }: PropsWithChildren) => {
  const hasGlobalAdminPermission = useSelector(getHasPermission('global_admin'));
  const hasAdministrationPermission = useSelector(getHasPermission('administration'));
  const navigate = useNavigate();

  useEffect(() => {
    if (hasGlobalAdminPermission === false && hasAdministrationPermission === false) {
      navigate(ROUTES.ROOT, { replace: true });
    }
  }, [hasGlobalAdminPermission, hasAdministrationPermission, navigate]);

  if (hasGlobalAdminPermission === false && hasAdministrationPermission === false) {
    return null;
  }

  return <>{children}</>;
};

export default AdministrationProtectedRoute;
